module.exports = __webpack_public_path__ + "resources/img/m_banner6.db23185485bb958e0a17a84423487852.png";